var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from '@/libs/axios';
var PlantillaCorreoService = /** @class */ (function () {
    function PlantillaCorreoService() {
        this.baseUrl = 'plantillas-correo';
    }
    // Obtener todas las plantillas
    PlantillaCorreoService.prototype.getAllPlantillas = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get(this.baseUrl)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error al obtener plantillas:', error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Obtener plantillas activas
    PlantillaCorreoService.prototype.getPlantillasActivas = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("".concat(this.baseUrl, "/activas"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Error al obtener plantillas activas:', error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Obtener plantilla por ID
    PlantillaCorreoService.prototype.getPlantillaById = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("".concat(this.baseUrl, "/").concat(id))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_3 = _a.sent();
                        console.error('Error al obtener plantilla:', error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Buscar plantillas por nombre
    PlantillaCorreoService.prototype.buscarPlantillas = function (nombre) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("".concat(this.baseUrl, "/buscar"), {
                                params: { nombre: nombre }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_4 = _a.sent();
                        console.error('Error al buscar plantillas:', error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Obtener plantillas por creador
    PlantillaCorreoService.prototype.getPlantillasByCreador = function (idCreadaPor) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("".concat(this.baseUrl, "/creador/").concat(idCreadaPor))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_5 = _a.sent();
                        console.error('Error al obtener plantillas por creador:', error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Crear nueva plantilla
    PlantillaCorreoService.prototype.createPlantilla = function (plantilla, idCreadaPor) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post(this.baseUrl, plantilla, {
                                params: { idCreadaPor: idCreadaPor }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_6 = _a.sent();
                        console.error('Error al crear plantilla:', error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Actualizar plantilla
    PlantillaCorreoService.prototype.updatePlantilla = function (id, plantilla) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.put("".concat(this.baseUrl, "/").concat(id), plantilla)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_7 = _a.sent();
                        console.error('Error al actualizar plantilla:', error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Eliminar plantilla
    PlantillaCorreoService.prototype.deletePlantilla = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.delete("".concat(this.baseUrl, "/").concat(id))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_8 = _a.sent();
                        console.error('Error al eliminar plantilla:', error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Activar/desactivar plantilla
    PlantillaCorreoService.prototype.toggleActiva = function (id, activa) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.put("".concat(this.baseUrl, "/").concat(id, "/toggle-activa"), null, {
                                params: { activa: activa }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_9 = _a.sent();
                        console.error('Error al cambiar estado de plantilla:', error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Obtener variables de una plantilla
    PlantillaCorreoService.prototype.getVariables = function (idPlantilla) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("".concat(this.baseUrl, "/").concat(idPlantilla, "/variables"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_10 = _a.sent();
                        console.error('Error al obtener variables:', error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Añadir variable a plantilla
    PlantillaCorreoService.prototype.addVariable = function (idPlantilla, variable) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("".concat(this.baseUrl, "/").concat(idPlantilla, "/variables"), variable)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_11 = _a.sent();
                        console.error('Error al añadir variable:', error_11);
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Actualizar variable
    PlantillaCorreoService.prototype.updateVariable = function (idPlantilla, idVariable, variable) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.put("".concat(this.baseUrl, "/").concat(idPlantilla, "/variables/").concat(idVariable), variable)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_12 = _a.sent();
                        console.error('Error al actualizar variable:', error_12);
                        throw error_12;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Eliminar variable
    PlantillaCorreoService.prototype.deleteVariable = function (idPlantilla, idVariable) {
        return __awaiter(this, void 0, Promise, function () {
            var error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.delete("".concat(this.baseUrl, "/").concat(idPlantilla, "/variables/").concat(idVariable))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_13 = _a.sent();
                        console.error('Error al eliminar variable:', error_13);
                        throw error_13;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Procesar plantilla con valores
    PlantillaCorreoService.prototype.procesarPlantilla = function (idPlantilla, valores) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("".concat(this.baseUrl, "/").concat(idPlantilla, "/procesar"), valores)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_14 = _a.sent();
                        console.error('Error al procesar plantilla:', error_14);
                        throw error_14;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Procesar plantilla con adjuntos y destinatarios
    PlantillaCorreoService.prototype.procesarPlantillaConAdjuntos = function (formData) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("".concat(this.baseUrl, "/procesar-con-adjuntos"), formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                                timeout: 60000, // 60 segundos para archivos grandes
                                onUploadProgress: function (progressEvent) {
                                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    console.log("Progreso de carga: ".concat(percentCompleted, "%"));
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_15 = _a.sent();
                        console.error('Error al procesar plantilla con adjuntos:', error_15);
                        throw error_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Crear plantilla con adjuntos
    PlantillaCorreoService.prototype.createPlantillaConAdjuntos = function (formData, idCreadaPor) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("".concat(this.baseUrl, "/con-adjuntos"), formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                                timeout: 60000, // 60 segundos para archivos grandes
                                onUploadProgress: function (progressEvent) {
                                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    console.log("Progreso de carga: ".concat(percentCompleted, "%"));
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_16 = _a.sent();
                        console.error('Error al crear plantilla con adjuntos:', error_16);
                        throw error_16;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Actualizar plantilla con adjuntos
    PlantillaCorreoService.prototype.updatePlantillaConAdjuntos = function (id, formData) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.put("".concat(this.baseUrl, "/").concat(id, "/con-adjuntos"), formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                                timeout: 60000, // 60 segundos para archivos grandes
                                onUploadProgress: function (progressEvent) {
                                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    console.log("Progreso de carga: ".concat(percentCompleted, "%"));
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_17 = _a.sent();
                        console.error('Error al actualizar plantilla con adjuntos:', error_17);
                        throw error_17;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Enviar correo libre (sin plantilla)
    PlantillaCorreoService.prototype.enviarCorreoLibre = function (data) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("".concat(this.baseUrl, "/enviar-libre"), data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_18 = _a.sent();
                        console.error('Error al enviar correo libre:', error_18);
                        throw error_18;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Enviar correo libre con adjuntos (multipart/form-data)
    PlantillaCorreoService.prototype.enviarCorreoLibreConAdjuntos = function (formData) {
        return __awaiter(this, void 0, Promise, function () {
            var response, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("".concat(this.baseUrl, "/enviar-libre-con-adjuntos"), formData, {
                                headers: { 'Content-Type': 'multipart/form-data' },
                                timeout: 60000,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_19 = _a.sent();
                        console.error('Error al enviar correo libre con adjuntos:', error_19);
                        throw error_19;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return PlantillaCorreoService;
}());
export default new PlantillaCorreoService();
